export function simplifiedAlertSortingAlgo(a, b, alertStore) {
  const aSortingInfo = alertStore.alertSortingStore[a];
  const bSortingInfo = alertStore.alertSortingStore[b];
  const aAlert = alertStore.alertTradePlansById[a];
  const bAlert = alertStore.alertTradePlansById[b];
  let aDeactivated = false;
  let bDeactivated = false;
  if (
    aAlert.restartSystemOncePositionHasFlattened &&
    aAlert.restartSettings.deactivateOnRestart &&
    aAlert.restartSettings.deactivated
  )
    aDeactivated = true;
  if (
    bAlert.restartSystemOncePositionHasFlattened &&
    bAlert.restartSettings.deactivateOnRestart &&
    bAlert.restartSettings.deactivated
  )
    bDeactivated = true;
  if (aDeactivated && !bDeactivated) return 1;
  if (bDeactivated && !aDeactivated) return -1;
  const aNotPassing = Object.values(aSortingInfo.filters).some(
    (item) => item.status === false
  );
  const bNotPassing = Object.values(bSortingInfo.filters).some(
    (item) => item.status === false
  );
  if (aNotPassing && !bNotPassing) return 1;
  if (!aNotPassing && bNotPassing) return -1;
  if (aSortingInfo.score === bSortingInfo.score) {
    return aAlert.symbol.localeCompare(bAlert.symbol, 'en', {
      sensitivity: 'base',
    });
  }
  if (aSortingInfo.score < bSortingInfo.score) return -1;
  else return 1;
}

// {
//   "maxRestartAttempts": 0,
//   "maxLoss": 0,
//   "maxMinutesInTradePlan": 0,
//   "numberOfTrades": 0,
//   "deactivateOnRestart": true,
//   "restartsAttempted": 0,
//   "minutesInTradePlan": 0,
//   "realizedProfit": 0,
//   "tradeCount": 0,
//   "deactivated": false
// }
